import { useState } from 'react'
import Conversations from './conversations'
import Messages from './messages'
import { StyleChatInterfaceWrapper } from './style'

const Chat = () => {
  return (
    <StyleChatInterfaceWrapper>
      <Conversations />
      <Messages />
    </StyleChatInterfaceWrapper>
  )
}

export default Chat
